import React, { useContext } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeCategoryPositionContext,
	IChangeCategoryPositionContext,
} from '../changeCategoryPositionState/changeCategoryPositionContext';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import { ChangePositionControlPanel } from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import { ChangePositionList } from './components/ChangePositionList/ChangePositionList';
import { ModalWindows } from './components/ModalWindows/ModalWindows';
import { BtnBlock } from './components/BtnBlock';
import { AdditionalRestaurantsModal } from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import style from './ChangeCategoryPosition.module.scss';

export const ChangeCategoryPosition: React.FC = () => {
	const { isLoading } = useContext<IAppContext>(AppContext);
	const { positionsData, selectedRestaurant } =
		useContext<IChangeCategoryPositionContext>(ChangeCategoryPositionContext);

	return (
		<div className={style.container} data-test="ChangeCategoryPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!selectedRestaurant} />
			)}
			<NoFiltersChangePosition isVisible={!selectedRestaurant} />
		</div>
	);
};
